<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <core-table
          :config="config"
          hide-upsert
          title="MedDRA Lower level term list"
        >
          <template slot="headerActions">
            <slot name="headerActions" />
            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <v-btn
                  v-on="on"
                  :loading="loadingImport"
                  v-if="$can('import', 'meddra')"
                  color="secondary"
                  @click="importZip()"
                >
                  <v-icon>mdi-upload</v-icon>
                </v-btn>
              </template>
              <span>Update MedDRA database</span>
            </v-tooltip>

            <!-- //issue 172 -->
            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <v-btn
                  v-on="on"
                  :loading="loadingImport"
                  v-if="$can('audit_trail', 'meddra')"
                  color="secondary"
                  @click="showAuditTrail()"
                >
                  <v-icon>mdi-timeline-clock</v-icon>
                </v-btn>
              </template>
              <span>Audit trail</span>
            </v-tooltip>
            <!-- //issue 172 -->

            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <v-btn
                  v-on="on"
                  :loading="loadingExport['csv']"
                  v-if="$can('export', 'meddra')"
                  color="secondary"
                  @click="export_csv()"
                >
                  <v-icon>mdi-file-delimited</v-icon>
                </v-btn>
              </template>
              <span>Export CSV</span>
            </v-tooltip>
          </template>
        </core-table>

        <!-- //issue 172 -->
        <v-dialog v-model="showaudit" max-width="1200px">
          <!-- //issue 178 -->
          <core-table
            :filters="{ section: 'Meddra' }"
            hide-upsert
            :config="config_log_meddra"
            title="Audit Trail"
          />
          <!-- //issue 178 -->
        </v-dialog>
        <!-- //issue 172 -->
      </v-flex>
    </v-layout>
    <app-meddra-upload-modal v-model="importModal" />
  </v-container>
</template>

<script>
//issue 172
import config from "./config_index.js";
import config_log_meddra from "@/views/config_log_meddra";

// config_log.fields = config_log.fields.filter((x) => x.value !== 'section')
// config_log.fields = config_log.fields.filter((x) => x.value !== 'action')
// config_log.fields = config_log.fields.filter((x) => x.value !== '_protocol')
// config_log.fields.find((x) => x.value === 'account.last_name').table.filter = false
// config_log.fields.find((x) => x.value === 'insert_at').table.filter = false
// config_log.fields.find((x) => x.value === 'account.last_name').table.sortable = false
// config_log.fields.find((x) => x.value === 'insert_at').table.sortable = false
//issue 172

import { export_data } from "@/api/export.js";

export default {
  data() {
    return {
      showaudit: false,
      config_log_meddra, //issue 172
      config,
      loadingImport: false,
      importModal: false,
      loadingExport: { csv: false },
    };
  },
  mounted() {},
  methods: {
    importZip() {
      this.importModal = true;
    },
    showAuditTrail() {
      this.showaudit = true;
    },
    export_csv() {
      this.loadingExport["csv"] = true;
      export_data("meddra", "csv").then(() => {
        this.loadingExport["csv"] = false;
      });
    },
  },
};
</script>
